const API_PATH = '/annuaire-associations/api/tenants/{{tenantId}}';
let apiHelperSingleton;

const apiHelperFactory = function() {
  function ApiHelper() {
    this.API_PATH = API_PATH;
    apiHelperSingleton = this;
  }

  ApiHelper.prototype.setPath = function(tenantId) {
    this.API_PATH = this.API_PATH.replace('{{tenantId}}', tenantId);
  };

  ApiHelper.prototype.getURI = function() {
    return this.API_PATH;
  };

  ApiHelper.prototype.buildURL = function(path) {
    return this.API_PATH.concat(path);
  };

  return apiHelperSingleton ? apiHelperSingleton : new ApiHelper();
};

apiHelperFactory();

export { apiHelperSingleton as apiHelper };
